/**
 * Allowed zipcode configuration for listing locations
 * 
 * This configuration restricts listings to specific countries/states based on zipcode ranges.
 * Using zipcode prefix ranges for efficient validation.
 * 
 * Current restrictions: Bay Area California (USA) and Romania (backdoor for testing)
 */

export const ALLOWED_STATES = {
  BAY_AREA: {
    name: 'Bay Area, California',
    abbreviation: 'CA',
    country: 'USA',
    format: 'US', // 5-digit zipcodes
    ranges: [
      { min: 940, max: 951 } // Covers 940xx through 951xx (SF Bay Area 9-county region)
    ]
  },
  ROMANIA: {
    name: 'Romania',
    abbreviation: 'RO',
    country: 'Romania',
    format: 'RO', // 6-digit postal codes
    ranges: [
      { min: 10, max: 927 } // Covers 010001 through 927xxx (first 2-3 digits)
    ]
  }
};

/**
 * Get list of allowed state/country names for error messages
 * @returns {string} Comma-separated list of allowed locations
 */
export const getAllowedStatesString = () => {
  const locations = Object.values(ALLOWED_STATES).map(state => state.name);
  if (locations.length === 2) {
    return locations.join(' and ');
  }
  const lastLocation = locations.pop();
  return locations.join(', ') + ', and ' + lastLocation;
};

/**
 * Get list of allowed state abbreviations
 * @returns {Array<string>} Array of state abbreviations
 */
export const getAllowedStateAbbreviations = () => {
  return Object.values(ALLOWED_STATES).map(state => state.abbreviation);
};

/**
 * Checks if a free-form address string is in Romania.
 * @param {string} address
 * @returns {boolean}
 */
export const isRomanianAddress = address => {
  return typeof address === 'string' && address.toLowerCase().includes('romania');
};
